import { Checkbox } from '@mui/material';
import DataTable from '../../../components/DataTable/DataTable';
import StateBadge from '../../../components/StatesBadge/StatesBadge';
import StateBadgeConvocated from '../../../components/StatesBadge/SateBadgeConvocated';
import { getEstadoExpuestoOptions } from '../consts/periodicosTypes';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';

const ConvocatedGrid = ({
    items,
    filters,
    setFilters,
    isFetching,
    translate,
    handleClickAction,
    handleOpenMenu
}: any) => {
    const { t } = useTranslation('periodicos');
    const getFechaContratoBadge = (fechaAlta: string | Date): React.ReactNode => {
        if (!fechaAlta) return '-';

        const fecha = new Date(fechaAlta);
        const hoy = new Date();
        const diffEnMs = hoy.getTime() - fecha.getTime();
        const diffEnDias = Math.floor(diffEnMs / (1000 * 60 * 60 * 24));

        let estado: 'activo' | 'presentado' | 'inactivo' | null = null;

        if (diffEnDias >= 90) {
            estado = 'inactivo';
        } else if (diffEnDias >= 60) {
            estado = 'presentado';
        } else if (diffEnDias >= 30) {
            estado = 'activo';
        }

        return estado ? (
            <StateBadge state={estado} text={fecha.toLocaleDateString()} hideIcon />
        ) : (
            <span>{fecha.toLocaleDateString()}</span>
        );
    };

    return (
        <DataTable
            columnTitles={[
                '',
                'CUIL',
                'Nombre y Apellido',
                'Localidad',
                'Contrato',
                'Inicio Contrato',
                'Riesgo',
                'Exámen Asignado',
                'Prestador',
                'Estado',
                'Acciones'
            ]}
            columnWidths={['2%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '2%']}
            filters={filters}
            setFilters={setFilters}
            isFetching={isFetching}
            items={items}
            headers={[
                {
                    type: 'data',
                    upperLabel: (item: any) => <Checkbox />
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        item?.cuil ||
                        item?.empleado?.cuil ||
                        item?.examenEmpleado?.empleado?.cuil ||
                        '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        `${item?.nombre || ''} ${
                            item?.apellido ||
                            item?.empleado?.nombre ||
                            item?.examenEmpleado?.empleado?.nombre ||
                            ''
                        }`
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        item?.establecimiento?.direccion?.localidad?.nombre ||
                        item?.empleado?.establecimiento?.direccion?.localidad?.nombre ||
                        item?.examenEmpleado?.empleado?.establecimiento?.direccion?.localidad
                            ?.nombre ||
                        '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        `${
                            item?.organismo?.organismoCentral?.cuit ||
                            item?.empleado?.organismo?.organismoCentral?.cuit ||
                            item?.examenEmpleado?.empleado?.organismo?.organismoCentral?.cuit ||
                            ''
                        } - ${
                            item?.organismo?.organismoCentral?.nombre ||
                            item?.examenEmpleado?.empleado?.organismo?.organismoCentral?.nombre ||
                            item?.empleado?.organismo?.organismoCentral?.nombre ||
                            ''
                        }`
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        getFechaContratoBadge(
                            item?.empleado?.organismo?.organismoCentral?.fechaInicioContrato ||
                                item?.organismo?.organismoCentral?.fechaInicioContrato ||
                                item?.examenEmpleado?.empleado?.organismo?.organismoCentral
                                    ?.fechaInicioContrato
                        )
                },

                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        `${item?.riesgo?.codigo || item?.examenEmpleado?.riesgo?.codigo || ''} - ${
                            item?.riesgo?.descripcion ||
                            item?.examenEmpleado?.riesgo?.descripcion ||
                            ''
                        }`
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        item?.examen?.descripcion || item?.examenEmpleado?.examen?.descripcion || ''
                },
                {
                    type: 'data',
                    upperLabel: (item: any) =>
                        item?.prestador?.razonSocial ||
                        item?.examenEmpleado?.prestador?.razonSocial ||
                        '-'
                },
                {
                    type: 'data',
                    upperLabel: (item: any) => (
                        <StateBadgeConvocated
                            hideIcon
                            state={item?.examenEmpleado?.idEstadoEmpleadoExpuesto}
                            text={(() => {
                                const estado = getEstadoExpuestoOptions(t).find(
                                    (opt: any) =>
                                        opt.id === item?.examenEmpleado?.idEstadoEmpleadoExpuesto
                                );
                                return estado ? (t(estado.nombre) as string) : '-';
                            })()}
                        />
                    )
                },

                {
                    type: 'action',
                    onClick: handleOpenMenu
                }
            ]}
        />
    );
};

export default ConvocatedGrid;
